import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from '@mui/material';
import { Select, SelectedItems } from '@backstage/core-components';

interface DialogEditProps {
  open: boolean;
  id: string | undefined;
  type: string | undefined;
  name: string | undefined;
  description: string | undefined;
  onClose: () => void;
  onSave: (
    id: string | undefined,
    name: string,
    type: string,
    description: string,
  ) => void;
}

export function DialogEdit(props: Readonly<DialogEditProps>) {
  const types = [
    { label: 'Website', value: 'Website' },
    { label: 'Service', value: 'Service' },
    { label: 'Database', value: 'Database' },
    { label: 'Job', value: 'Job' },
    { label: 'Workflow', value: 'Workflow' },
    { label: 'Library', value: 'Library' },
  ];
  const [id, setId] = useState<undefined | string>();
  const [name, setName] = useState<string | undefined>();
  const [type, setType] = useState<SelectedItems | undefined>();
  const [description, setDescription] = useState<string | undefined>();

  useEffect(() => {
    setId(props.id);
  }, [props.id]);

  useEffect(() => {
    setName(props.name);
  }, [props.name]);

  useEffect(() => {
    setType(props.type);
  }, [props.type]);

  useEffect(() => {
    setDescription(props.description);
  }, [props.description]);

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle>Edit</DialogTitle>
      <DialogContent>
        <Select
          label="Type"
          items={types}
          onChange={(e: SelectedItems) => {
            setType(e);
          }}
          multiple={false}
          selected={type}
          margin="dense"
        ></Select>
        <TextField
          autoFocus
          label="Name *"
          error={name?.length === 0}
          helperText={
            name?.length === 0 ? 'This field must be filled' : undefined
          }
          type="text"
          margin="dense"
          fullWidth
          value={name}
          onChange={(e: any) => setName(e.target.value)}
        />
        <TextField
          label="Description"
          type="text"
          margin="dense"
          multiline={true}
          fullWidth
          value={description}
          onChange={(e: any) => {
            setDescription(e.target.value);
          }}
        ></TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>Cancel</Button>
        <Button
          disabled={name?.length === 0}
          onClick={() =>
            props.onSave(id, name!, type as string, description ?? '')
          }
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
